import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './styles/global.scss';
import dcPerm from '@/mixins/dcPerm';

Vue.use(ElementUI, { size: 'small' });
Vue.mixin(dcPerm);
Vue.directive('perm', {
  inserted(el, binding, vnode) {
    const vm = vnode.context;
    const can = vm && typeof vm.dcCan === 'function' ? vm.dcCan(binding.value) : true;
    if (!can) el.style.display = 'none';
  }
});
Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'small' });
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
